import { renderBooleanIcon } from '../utility/dictionaryGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DICTIONARY_CATEGORY = {
  STATE: 'codeStates',
  CITY: 'codeCities',
};

export const DEFAULT_VALUES = {
  ptsCityID: null,
  CityDescription: '',
  State: '',
  Category: '',
  IsDefault: false,
  IsActive: true,
  IsDeleted: false,
};

export const CITY_GRID_COLUMNS = [
  { field: 'CityDescription', title: 'City' },
  { field: 'State', title: 'State' },
  { field: 'Category', title: 'Category' },
  { field: 'IsDefault', title: 'Is Default', render: renderBooleanIcon },
  { field: 'IsActive', title: 'Is Active', render: renderBooleanIcon },
];
